<template>
  <div :class="bestBeforeClass(stock)" v-if="stock.item.trackBestBeforeDate && stock.bestBeforeAsDate">{{ $d(stock.bestBeforeAsDate, 'dateonly') }}</div>
</template>

<script setup lang="ts">
import ITrackableStock from "@/models/ITrackableStock";

const props = defineProps({
  stock: { type: Object as () => ITrackableStock, required: true },
  ignoreLeadTime: { type: Boolean, required: false, default: false },
});

function bestBeforeClass(stock: ITrackableStock) {
  return {
    'bg-danger text-light': stock.bestBeforeExceeded,
    'bg-warning text-dark': !props.ignoreLeadTime && !stock.bestBeforeExceeded && stock.bestBeforeLeadTimeReached
  };
}
</script>
